import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const NotificationApi = createApi({
  reducerPath: "NotificationApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["NOTIFICATION"],
  endpoints: (build) => ({
    // Admin endpoints
    sendToUsers: build.mutation({
      query: (body) => ({
        url: "/notifications/send/users",
        method: "POST",
        body,
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      }),
      invalidatesTags: ["NOTIFICATION"],
    }),

    sendToDrivers: build.mutation({
      query: (body) => ({
        url: "/notifications/send/drivers",
        method: "POST",
        body,
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      }),
      invalidatesTags: ["NOTIFICATION"],
    }),

    sendToAllUsers: build.mutation({
      query: (body) => ({
        url: "/notifications/send/all-users",
        method: "POST",
        body,
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      }),
      invalidatesTags: ["NOTIFICATION"],
    }),

    adminListNotifications: build.query({
      query: (params = {}) => {
        const queryParams = new URLSearchParams();
        Object.keys(params).forEach((key) => {
          if (params[key] !== undefined && params[key] !== "") {
            queryParams.append(key, params[key]);
          }
        });
        const queryString = queryParams.toString();
        return {
          url: `/notifications/admin/list${
            queryString ? `?${queryString}` : ""
          }`,
          method: "GET",
          headers: { "Content-Type": "application/json; charset=UTF-8" },
        };
      },
      providesTags: ["NOTIFICATION"],
    }),

    adminDeleteNotification: build.mutation({
      query: ({ notificationId }) => ({
        url: `/notifications/admin/${notificationId}`,
        method: "DELETE",
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      }),
      invalidatesTags: ["NOTIFICATION"],
    }),
  }),
});

export const {
  useSendToUsersMutation,
  useSendToDriversMutation,
  useSendToAllUsersMutation,
  useAdminListNotificationsQuery,
  useAdminDeleteNotificationMutation,
} = NotificationApi;
